<template>
  <transition name="fadescale">
    <div>
      <div class="grow">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {};
</script>
<style lang="scss">
.fadescale-enter-active,
.fadescale-leave-active {
  transition: all 500ms ease;
}
.fadescale-enter, .fadescale-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  .grow {
    // margin-bottom: -100%;
  }
}
.fadescale-leave, .fadescale-enter-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 1;
  .grow {
    // margin-bottom: 0;
  }
}
</style>